import { Tabs } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const CategoryNav = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const items = [
    {
      key: 1,
      label: "Service Categories",
    },
    {
      key: 2,
      label: "Sub-Service Categories",
    },
  ];

  const onChange = (key) => {
    if (key === 1) {
      navigate("/main/categories");
    } else {
      navigate("/main/categories/subservice");
    }
  };

  const [activeLink, setActiveLink] = useState(1);

  useEffect(() => {
    if (pathname === "/main/categories/subservice") {
      setActiveLink(2);
    } else {
      setActiveLink(1);
    }
  }, [pathname]);

  return (
    <div className="pt-2 px-2 w-full flex flex-row justify-between">
      <Tabs
        defaultActiveKey={1}
        activeKey={activeLink}
        items={items}
        onChange={onChange}
      />
    </div>
  );
};

export default CategoryNav;
